// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65334dcc","455":"c128434e","977":"2191b3dd"}[chunkId] + ".chunk.js";
};